import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { AlumnoData } from '../../assets/styled';
import { AlumnosContext } from '../../context/alumnos/AlumnosContext';
import FichaCards from './FichaCards';

function AlumnoProfile() {
	const dataAlumno = useContext(AlumnosContext);
	const { id } = useParams('id');
	const { alumnos, getAlumnoById, data: dataForm, getAlumnos } = dataAlumno;
	const [añoSeleccionado, setAñoSeleccionado] = useState(new Date().getFullYear());
	
	const alumno = alumnos.find((alumno) => alumno.id === id) || (dataForm && dataForm.id === id ? dataForm : null);

	useEffect(() => {
		if (!alumno) {
			getAlumnoById(id);
		}
		if (alumnos.length === 0) {
			getAlumnos(true);
			getAlumnos(false);
		}
	}, [id, alumno, alumnos.length, getAlumnoById, getAlumnos]);

	if (!alumno || (alumno.id !== id && !alumno._id)) return <div className="text-center mt-5">Cargando datos del alumno...</div>;

	return (
		<div
			style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', padding: '20px' }}
		>
			<br />
			<div>
				<AlumnoData color='#000'>{`Alumno: ${alumno.nombre} ${alumno.apellido}`}</AlumnoData>
				<AlumnoData color='#000'>{`Categoria ${alumno.categoria}`}</AlumnoData>
			</div>
			
			<div style={{ margin: '20px 0', width: '100%', maxWidth: '300px' }}>
				<label style={{ marginRight: '10px', fontWeight: 'bold' }}>Seleccionar Año:</label>
				<select
					value={añoSeleccionado}
					onChange={(e) => setAñoSeleccionado(parseInt(e.target.value))}
					className='form-select'
				>
					{Array.from({ length: 5 }, (_, i) => {
						const año = new Date().getFullYear() - 2 + i;
						return (
							<option key={año} value={año}>
								{año}
							</option>
						);
					})}
				</select>
			</div>

			<Link to={`/${alumno.dni}`} style={{ marginBottom: '20px' }}>Ver Credencial de Pagos</Link>
			
			<FichaCards alumno={alumno} añoSeleccionado={añoSeleccionado} />
		</div>
	);
}

export default AlumnoProfile;
